export const RegistrationFlowType = {
  SELF: 'self',
  PRINCIPAL: 'principal',
}

export const BUYER_REGISTRATION_STEPS = {
  DETAILS: 'details',
  PRINCIPAL_DOCS: 'principalDocs',
  REVIEW: 'review',
  SIGN_SUBMIT: 'signSubmit',
  PAYMENT: 'payment',
  LOTS_SELECTION: "lotsSelection",
  Bidding_Limit: "biddingLimit"
};


export const BUYER_REGISTRATION_STEPS_BY_INDEX = {
  principal: {
    1: BUYER_REGISTRATION_STEPS.DETAILS,
    2: BUYER_REGISTRATION_STEPS.PRINCIPAL_DOCS,
    3: BUYER_REGISTRATION_STEPS.REVIEW,
    4: BUYER_REGISTRATION_STEPS.SIGN_SUBMIT,
    5: BUYER_REGISTRATION_STEPS.PAYMENT,
  },
  self: {
    1: BUYER_REGISTRATION_STEPS.DETAILS,
    2: BUYER_REGISTRATION_STEPS.DETAILS,
    3: BUYER_REGISTRATION_STEPS.SIGN_SUBMIT,
    4: BUYER_REGISTRATION_STEPS.PAYMENT,
  },
};

export const BUYER_REGISTRATION_STEPS_LIVE_BY_INDEX = {
  principal: {
    1: BUYER_REGISTRATION_STEPS.DETAILS,
    2: BUYER_REGISTRATION_STEPS.LOTS_SELECTION,
    3: BUYER_REGISTRATION_STEPS.Bidding_Limit,
    4: BUYER_REGISTRATION_STEPS.Bidding_Limit,
    5: BUYER_REGISTRATION_STEPS.PAYMENT,
  },
  self: {
    1: BUYER_REGISTRATION_STEPS.DETAILS,
    2: BUYER_REGISTRATION_STEPS.LOTS_SELECTION,
    3: BUYER_REGISTRATION_STEPS.Bidding_Limit,
    4: BUYER_REGISTRATION_STEPS.Bidding_Limit,
    5: BUYER_REGISTRATION_STEPS.PAYMENT,
  },
};

export const Set_Bid_Registration_Doc = "set_bid_registration_doc"

export const Payment_Method = {
  CARD: "CARD",
  ESCROW: "ESCROW"
}

export const ID_TYPE = [
  { label: "Passport", value: 1 },
  { label: "National ID", value: 2 },
];

export const EMPTY = [];
